import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useModal } from "../hooks/useModal";

const SettingsModal = () => {
  const navigate = useNavigate();
  const { logout } = useAuth({}); 
  const {closeModal} = useModal();

  return (
    <div className='w-full flex flex-col gap-2 select-none'>
      <h1 className='text-[22px] font-bold mb-4'>설정</h1>
      <button className='w-full p-2 text-center font-semibold bg-gray-100 rounded-lg' onClick={() => {
        navigate('/faq');
        closeModal();
      }}>FAQ</button>
      <button className='w-full p-2 text-center font-semibold bg-gray-100 rounded-lg' onClick={() => {
        closeModal();
        navigate('/profile');
      }}>내 정보 수정</button>
      <button className='w-full p-2 text-center font-semibold bg-gray-100 rounded-lg' onClick={() => {
        navigate('/profile/link-kakaopay');
        closeModal();
      }}>카카오페이 연동</button>
      <button className='w-full p-2  text-center font-semibold bg-red-100 text-red-500 rounded-lg' onClick={() => {
        closeModal();
        logout();
      }}>로그아웃</button>
    </div>
  );
};

export default SettingsModal;